import { createContext, useContext, useRef, type ReactNode } from "react";
import type { ProductionHistory } from "@/features/devices/types";

/** CACHE de historico, nunca de leitura atual. Vive apenas na sessao da aba. */
export class HistoryCache {
  generation = 0;
  private entries = new Map<string, { data: ProductionHistory; fetchedAt: number }>();
  get(key: string): ProductionHistory | undefined {
    const entry = this.entries.get(key);
    if (!entry) return undefined;
    if (Date.now() - entry.fetchedAt >= 60_000) { this.entries.delete(key); return undefined; }
    return entry.data;
  }
  set(key: string, data: ProductionHistory) {
    this.entries.delete(key);
    this.entries.set(key, { data, fetchedAt: Date.now() });
    if (this.entries.size > 64) this.entries.delete(this.entries.keys().next().value!);
  }
  delete(key: string) { this.entries.delete(key); }
  clear() { this.generation++; this.entries.clear(); }
}
const Context = createContext<HistoryCache | null>(null);
export function HistoryCacheProvider({ cache, children }: { cache: HistoryCache; children: ReactNode }) {
  return <Context.Provider value={cache}>{children}</Context.Provider>;
}
export function useHistoryCache() {
  const shared = useContext(Context);
  const local = useRef<HistoryCache | null>(null);
  if (!local.current) local.current = new HistoryCache();
  return shared ?? local.current;
}
